export { DialogDeleteComponent } from './dialog-delete/dialog-delete.component';
export { DialogInfoComponent } from './dialog-info/dialog-info.component';
export { DialogGalleryComponent } from './dialog-gallery/dialog-gallery.component';
export { DialogNewImageComponent } from './dialog-new-image/dialog-new-image.component';